import PropTypes from "prop-types";
import styled from "styled-components";

export const Container = styled.li`
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: ${props => props.align || "center"};
  width: 100%;
  text-align: center;
  font-size: 11px;
  -webkit-transition: background-color ease 0.25s;
  -moz-transition: background-color ease 0.25s;
  transition: background-color ease 0.25s;
`;

export const Item = styled.div`
  text-align: center;
`;

export const ItemImage = styled.img`
  width: 1.5rem;
  margin-bottom: 0.25rem;
  margin-left: auto;
  margin-right: auto;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;

export const ItemText = styled.div``;

export const defaultProps = {
  onClick: () => {},
  image: null,
  text: "",
  active: false,
  disabled: false,
  align: "center"
};

export const propTypes = {
  onClick: PropTypes.func,
  image: PropTypes.any,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  height: PropTypes.string,
  align: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/SideBar/SideBarItem.js